module.exports = __webpack_public_path__ + "static/img/36.19c5df4b.png";